import { useState } from 'react';

import { getExpiredAndCurrentFAGroups } from '@fora-monorepo/employer-my-pages-common/utils';
import { FAGroupViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import {
  Assets,
  Box,
  Container,
  CopyToClipBoardButton,
  DateRangeItemDetails,
  FAQ,
  Link,
  ParsedHtmlContent,
  QuestionsAndAnswersType,
  Text,
  theme,
  useMediaMin,
  VerticalSpacer,
  WideBox,
} from '@foradevelopment/fora-ui';
import { RichTextContentBlockViewModel } from '@fora-monorepo/epi-content-common';

import { useTypedTranslation } from '../../i18n/i18n';

export const Markups = ({
  markupList,
  faq,
  ingress,
}: {
  markupList: FAGroupViewModel[];
  faq: QuestionsAndAnswersType[];
  ingress: RichTextContentBlockViewModel | null;
}) => {
  const { t } = useTypedTranslation();

  const { expiredFAGroups, currentFAGroups } = getExpiredAndCurrentFAGroups(markupList);
  const isDesktop = useMediaMin(theme.breakpoint.lg);

  const [clickedIndex, setClickedIndex] = useState<number | null>(null);

  return (
    <Container maxWidth={[728, 728, 578]} marginLeft="auto" marginRight="auto">
      <ParsedHtmlContent htmlContent={ingress?.body ?? ''} />
      <VerticalSpacer marginBottom={10} />
      <Link to="https://www.fora.se/personalkategorier">{t('markups.ingressLink')}</Link>
      <Box marginTop={60}>
        {currentFAGroups.map((FAGroup, ind) => {
          return (
            <WideBox key={ind} backgroundColor="white" marginBottom={2}>
              <CopyToClipBoardButton
                title={FAGroup.fokId}
                setClickedIndex={setClickedIndex}
                clickedIndex={clickedIndex !== null ? clickedIndex : undefined}
                ind={ind}
                copyConfirmationText={t('infoMessages.fokToClipBoardText')}
              />
              <DateRangeItemDetails
                terminology="validFromTo"
                subTitle={FAGroup.fokText}
                startDate={FAGroup.validFrom}
                endDate={FAGroup.validTo || t('common.labels.ongoing')}
              />
            </WideBox>
          );
        })}
      </Box>
      {expiredFAGroups.length > 0 && (
        <Box marginTop={60}>
          {expiredFAGroups.map((FAGroup, ind) => {
            return (
              <WideBox key={ind} backgroundColor="babyPink" marginBottom={2}>
                <Assets.CircleInfoIcon width={22} color="burgundyDark" />
                <Box marginBottom={20}>
                  <Text fontWeight="semibold" color="burgundyDark">
                    {t('markups.markupDetails.expired')}
                  </Text>
                </Box>
                <DateRangeItemDetails
                  terminology="validFromTo"
                  title={FAGroup.fokId}
                  subTitle={FAGroup.fokText}
                  startDate={FAGroup.validFrom}
                  endDate={FAGroup.validTo}
                  backgroundColor="babyPink"
                />
              </WideBox>
            );
          })}
        </Box>
      )}
      {faq.length > 0 && (
        <FAQ testId="review-confirm-faq" layout={isDesktop ? 'drawer' : 'modal'} questionAnswers={faq} />
      )}
    </Container>
  );
};
